import React from "react";
//import ReactPlayer from 'react-player';
import { cn } from "../lib/helpers";
import loadable from '@loadable/component';

const ReactPlayer = loadable(() => import('react-player'));

import * as styles from "../styles/components/fc-video.module.css";

const Video = (props) => {

  const {
    _key,
    url,
    caption
  } = props;

  return (
    <div className={styles.root} key={_key}>
      {url && (
        <div className={styles.player}>
          <ReactPlayer 
            url={url}
            controls={true}
            width="100%"
            height="100%"
          />
        </div>
      )}
      {caption && (<div className="caption">{caption}</div>)}
    </div> 
  );
};

export default Video;
